import { useApplyEdition } from '@/pages/Apply/components/use-apply-edition';
import { useState } from 'react';
import { csrfToken } from '@/lib/csrf';

interface Props {
  /**
   * Where to land after signing out. Defaults to the 26-co apply landing so
   * the user can re-enter the flow from a clean slate.
   */
  redirectTo?: string;
}

export function LogoutLink({ redirectTo }: Props) {
  const { eventSlug } = useApplyEdition();
  const [isPending, setIsPending] = useState(false);

  // The same endpoint the better-auth client called (U4); the hard reload is what makes
  // the server re-evaluate the session.
  const handleLogout = async () => {
    setIsPending(true);
    try {
      await fetch('/api/auth/sign-out', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken(),
        },
      });
    } finally {
      window.location.href = redirectTo ?? `/${eventSlug}/apply`;
    }
  };

  return (
    <button
      type="button"
      onClick={handleLogout}
      disabled={isPending}
      className="fixed top-4 right-4 z-50 font-sans text-[10px] text-muted-foreground uppercase tracking-[0.18em] transition hover:text-foreground disabled:opacity-50 sm:top-6 sm:right-6 sm:text-xs"
    >
      {isPending ? 'Cerrando…' : 'Cerrar sesión'}
    </button>
  );
}
